module.exports = __webpack_public_path__ + "media/newstyle/images/auto_stories-fe0ee7b19980089e9a47a12ee6147234.svg";